
<template>
    <div class="container">
        <b-card>
            <b-row>
                <h3>Transportadoras</h3>
            </b-row>
            <b-row>
                <b-col>
                    <b-button size="sm" variant="primary" @click="addTransportadora"><i class="fa fa-tasks" /> Nova
                        Transportadora</b-button>
                </b-col>
                <b-col lg="6" class="my-1">
                    <b-form-group>
                        <b-input-group size="sm">
                            <b-form-input id="filter-input" v-model="filter" type="search"
                                placeholder="Buscar Transportadora"></b-form-input>
                            <b-input-group-append>
                                <b-button :disabled="!filter" @click="filter = ''">Limpar</b-button>
                            </b-input-group-append>
                        </b-input-group>
                    </b-form-group>
                </b-col>
            </b-row>
            <b-row>
                <b-col>
                    <b-table :items="transportadoras" :fields="colunas" :current-page="currentPage" :per-page="perPage"
                        :filter="filter" :filter-included-fields="filterOn" stacked="md" show-empty hover
                        @filtered="onFiltered">
                        <template #cell(editar)="row">
                            <b-button size="sm" variant="primary" @click="editar(row.item)"><i class="fa fa-edit" />
                            </b-button>
                        </template>
                    </b-table>
                </b-col>
            </b-row>
            <b-row>
                <b-col sm="7" md="6" class="my-1">
                    <b-pagination v-model="currentPage" :total-rows="totalRows" :per-page="perPage" align="fill" size="sm"
                        class="my-0">
                    </b-pagination>
                </b-col>
                <b-col class="text-right">
                    <span>Total de Transportadoras: {{ transportadoras.length }} </span>
                </b-col>
            </b-row>

            <!-- MODAL PARA INCLUIR UMA NOVA TRANSPORTADORA -->
            <b-modal size="xl" v-model="modalNovaTransportadora" title="Nova Transportadora">
                <div class="row">
                    <div class="col-md-4">
                        <label>Digite um código</label>
                        <input type="text" class="form-control" v-model="codigo" />
                    </div>
                    <div class="col-md-6">
                        <label>Nome:</label>
                        <input type="text" class="form-control" v-model="nome" />
                    </div>
                </div>
                <div class="row">
                    <div class="col-md-10 mt-2">
                        <label>Digite a URL <small>(endereço de rastreamento)</small></label>
                        <input type="text" class="form-control" v-model="url" />
                    </div>
                </div>
                <div class="row">
                    <div class="col-md-12">
                        <div class="form-group">
                            <label>Mensagem:</label>
                            <textarea v-model="mensagem" class="form-control"></textarea>
                        </div>
                    </div>
                </div>
                <template #modal-footer>
                    <b-button variant="primary" size="sm" @click="SalvaTransport"><i class="fa fa-save"></i>
                        Salvar</b-button>
                    <b-button variant="danger" size="sm" @click="modalNovaTransportadora = false">Cancelar</b-button>
                </template>
            </b-modal>
        </b-card>
    </div>
</template>

<script>
import vSelect from "vue-select";
import { VueEditor } from 'vue2-editor'

export default {
    props: [],
    components: { vSelect, VueEditor },
    data() {

        return {
            modalVisible: false,
            datePickerConfig: {
                'format': 'D/MM/YYYY',
                'showClose': true
            },
            search: "",
            colunas: [
                {
                    key: 'editar',
                    label: ''
                },
                {
                    key: 'codigo',
                    label: 'Código',
                    sortable: true
                },
                {
                    key: 'nome',
                    label: 'Transportadora',
                    sortable: true
                },
                // ["Código","codigo"],["Transportadora","nome"]
            ],
            data: [],
            mensagem: '',
            customToolbar: [
                ['bold', 'italic', 'underline'],
                [{ 'list': 'ordered' }, { 'list': 'bullet' }],
                ['code-block']
            ],
            nome: '',
            url: '',
            codigo: '',
            actionsTable: ['show'],
            descricao: null,
            meta: 0,
            catalogo: 0,
            descricao: null,
            status: null,
            distribuidor: null,
            listaDistribuidor: [],
            edita_id: 0,
            dataMeta: '',
            listaMeta: [],
            nomedistribuidor: '',
            errors: [],
            transportadoras: [],
            modalNovaTransportadora: false,
            totalRows: 1,
            currentPage: 1,
            perPage: 15,
            sortBy: 'codigo',
            sortDesc: false,
            sortDirection: 'asc',
            filter: null,
            filterOn: ['codigo', 'nome'],
        }
    },

    methods: {

        onFiltered(filteredItems) {
            this.totalRows = filteredItems.length
            this.currentPage = 1
        },

        clearForm() {
            this.codigo = '';
            this.edita_id = 0;
            this.nome = '';
            this.url = '';
            this.mensagem = '';
        },

        addTransportadora() {
            this.clearForm();
            this.modalNovaTransportadora = true;
        },

        loadData() {
            var vm = this;
            $('.loading').show();

            axios.get('/adm/transportadoras?lista=TODOS').then(function (response) {
                if (response) {
                    vm.transportadoras = response.data;
                    vm.totalRows = vm.transportadoras.length
                }
                $('.loading').hide();
            }).catch(function (error) {
                console.log(error);
                $('.loading').hide();
            });
        },

        editar(item) {
            var vm = this;
            var id = item.id
            $('.loading').show();
            axios.get('/adm/transportadoras?ver=' + id).then(function (response) {
                let list = response.data;
                vm.nome = list.nome;
                vm.codigo = list.codigo;
                vm.mensagem = list.mensagem;
                vm.url = list.url;
                vm.edita_id = list.id;

                $('.loading').hide();
                vm.modalNovaTransportadora = true;
            }).catch(function (error) {
                console.log(error);
                $('.loading').hide();
            });
        },

        valida() {
            if (this.codigo === "") {
                this.$swal('Ops', 'Código transportadora não preenchido', 'error');
                return false;
            }
            if (this.nome === '') {
                this.$swal('Ops', 'Descreva o nome da transportadora.', 'error');
                return false;
            }
            return true;
        },

        SalvaTransport() {
            if (!this.valida()) {
                return;
            }
            $('.loading').show();
            var vm = this;
            var data = {
                codigo: vm.codigo,
                nome: vm.nome,
                url: vm.url,
                mensagem: vm.mensagem,
                id: vm.edita_id
            }
            // console.log(data);

            axios.post('/adm/transportadoras/salva', data)
                .then(function (response) {
                    if (response.data) {
                        // console.log(response.data);
                        let obj = response.data.success;
                        if (obj) {
                            vm.$swal('Ok', response.data.success, 'success');
                        }
                        $('.loading').hide();
                        vm.modalNovaTransportadora = false;
                        vm.loadData();
                        vm.clearForm();
                    }
                }).catch(function (error) {
                    if (error) {
                        vm.$swal('Ops', error, 'error');
                        console.log(error);
                        $('.loading').hide();
                    }
                });
        },
    },
    computed: {
        sortOptions() {
            return this.fields
                .filter(f => f.sortable)
                .map(f => {
                    return { text: f.label, value: f.key }
                })
        }
    },
    created() {
        $('.loading').show();
    },
    mounted() {
        this.loadData();
        this.totalRows = this.transportadoras.length;
    }
}


</script>



// WEBPACK FOOTER //
// resources/assets/js/components/transportadora/List.vue